import { ElMessage } from 'element-plus'
import { useUserStoreWithOut } from '@/store/modules/user'
import encrypt from '@/utils/encrypt'
const changeOrigin = window.fetch;
const VUE_APP_TDS_SERVER = process.env.VUE_APP_TDS_SERVER;

window.fetch = (url, options = {}) => {
  const userStore = useUserStoreWithOut();
  const token = localStorage.getItem('token')

  options.headers = options?.headers || {}
  if (!options.headers['Content-Type'] && !(options.body instanceof FormData)) {
    options.headers['Content-Type'] = 'application/json'
  }
  const isAIServer = /^\/api/.test(url)
  if (isAIServer && !options.headers['Authorization']) {
    options.headers['Authorization'] = `Bearer ${process.env.VUE_APP_TOKEN}`;
  } else if (!isAIServer && token && !options.ignoreToken) {
    if (!options.headers['Authorization']) {
      options.headers['Authorization'] = `${token}`
    }
    if (!options.headers['X-Access-Token'] && !options.headers['x-access-token']) {
      options.headers['X-Access-Token'] = `${token}`
    }
  }

  if (userStore.userInfo?.loginTenantId) {
    options.headers['X-Tenant-Id'] = encrypt(userStore.userInfo.loginTenantId)
  }
  if (options.method === 'POST' || options.method === 'PUT' || options.method === 'DELETE' ) {
    options.body = typeof options.body === 'string' || options.body instanceof FormData ? options.body : JSON.stringify(options.body)
  }

  return changeOrigin(url, options)
}


export const tdsFetch = (url, options) => {
  const baseUrl = VUE_APP_TDS_SERVER;
  const userStore = useUserStoreWithOut();
  const isAIServer = /^\/api/.test(url);
  const hidePrefix = options.joinPrefix  === false || isAIServer;

  return new Promise((resolve, reject) => {
    fetch(hidePrefix ? url : baseUrl + url, options)
    .then(response => {
      if (response.status === 401) {
        if (!isAIServer && !options.ignoreToken) {
          userStore.setToken(undefined)
          userStore.logout();
        } else {
          ElMessage.error('接口认证失败')
        }
        resolve()
        return
      }
      if (response.ok) {
        if (options.responseType === 'blob') {
          response.blob().then(res => {
            resolve(res)
          })
        } else {
          response.json().then(res => {
            if (isAIServer){
              resolve(res)
            } else if (res.code === 500 || res.code === 510) {
              res.message && ElMessage.warning(res.message)
              resolve()
            } else if (res.code === 401) {
              userStore.setToken(undefined)
              userStore.logout();
              resolve()
            } else {
              resolve(res.result ? res.result : (res.code === 200 ? true : res.result))
            }
          })
        }
      }
    })
    .catch((err) => {
      if (err.name === 'AbortError') {
        resolve({ AbortError: true })
      } else {
        resolve()
        ElMessage.error('接口连接异常')
      }
    })
  })
}

export const jsonToQuery = (json) => {
  let str = '';
  Object.keys(json || {}).forEach((k, i) => {
    const val = typeof json[k] === 'string' ? json[k].trim() : json[k]
    str += val ? `${i === 0 ? '?' : '&'}${k}=${val}` : ''
  })
  return str
}
